import * as materialAdd from '../services/addMaterial';

export default {
  namespace: 'materialAdd',

  state: {},

  effects: {
    //添加素材
    *addMaterial({ payload: { values }, callback }, { call }) {
      const response = yield call(materialAdd.addMaterial, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //修改素材
    *updateMaterial({ payload: { values }, callback }, { call }) {
      //编辑的时候需要去掉文件路径前缀
      let path;
      const { filePath: noPrefixFilePath, ...restParam } = values;
      let filePath = values?.file;
      if (!noPrefixFilePath) {
        // filePath = filePath.replace(/^(https|http):\/\/[^/]+\//, '');
        path = filePath;
      } else {
        path = noPrefixFilePath;
      }
      const response = yield call(materialAdd.updateMaterial, {
        filePath: path,
        ...restParam,
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //查询单个素材
    *getMaterialDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(materialAdd.getMaterialDetail, values);
      yield put({
        type: 'save',
        payload: {
          materialDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除单个素材
    *deleteMaterial({ payload: { values }, callback }, { call }) {
      const response = yield call(materialAdd.deleteMaterial, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     materialDetail: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 清除数据
    *clearMaterialDetail({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          materialDetail: {},
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          [
            '/miniapps/material_list/material_edit',
            '/miniapps/material_list/material_add',
            '/miniapps/material_list/material_detail',
          ].includes(props.pathname)
        ) {
          dispatch({
            type: 'clearMaterialDetail',
            payload: {
              values: {
                materialDetail: {},
              },
            },
          });
        }
      });
    },
  },
};
